import React from 'react';

const fieldStyle = {
  width: '100%', padding: '0.375rem 0.75rem', fontSize: '0.875rem',
  border: '1px solid var(--border)', borderRadius: '0.375rem', outline: 'none'
};

const labelStyle = { display: 'block', marginBottom: '0.5rem', fontSize: '0.875rem', fontWeight: '500' };

const EmployeeModal = ({ isOpen, warehouses, users, employeeForm, setEmployeeForm, onSubmit, onClose, loading }) => {
  if (!isOpen) return null;

  const update = (field, value) => setEmployeeForm(prev => ({ ...prev, [field]: value }));

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex',
      justifyContent: 'center', alignItems: 'center', zIndex: 1050
    }}>
      <div style={{
        backgroundColor: 'var(--card-bg)', borderRadius: '0.375rem', padding: '1.5rem',
        minWidth: '400px', maxWidth: '500px',
        boxShadow: '0 0.5rem 1rem rgba(0,0,0,0.15)'
      }}>
        <h5 style={{ marginBottom: '1rem', fontWeight: '600' }}>
          Przypisz pracownika do magazynu
        </h5>

        <form onSubmit={onSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={labelStyle}>Magazyn *</label>
            <select required style={{ ...fieldStyle, backgroundColor: 'var(--card-bg)' }} value={employeeForm.warehouse_id}
              onChange={(e) => update('warehouse_id', e.target.value)}>
              <option value="">Wybierz magazyn</option>
              {warehouses.map(w => (
                <option key={w.id} value={w.id}>{w.nazwa} ({w.kod})</option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <label style={labelStyle}>Uzytkownik *</label>
            <select required style={{ ...fieldStyle, backgroundColor: 'var(--card-bg)' }} value={employeeForm.user_login}
              onChange={(e) => update('user_login', e.target.value)}>
              <option value="">Wybierz uzytkownika</option>
              {users.map(user => (
                <option key={user.id} value={user.login}>{user.login} ({user.role})</option>
              ))}
            </select>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <label style={labelStyle}>Rola w magazynie</label>
            <select style={{ ...fieldStyle, backgroundColor: 'var(--card-bg)' }} value={employeeForm.rola}
              onChange={(e) => update('rola', e.target.value)}>
              <option value="pracownik">Pracownik</option>
              <option value="kierownik">Kierownik</option>
              <option value="zastepca">Zastepca</option>
            </select>
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={labelStyle}>Uprawnienia (opcjonalne)</label>
            <textarea
              style={{ ...fieldStyle, resize: 'vertical', minHeight: '60px' }}
              value={employeeForm.uprawnienia}
              onChange={(e) => update('uprawnienia', e.target.value)}
              placeholder="Dodatkowe uprawnienia lub opis"
            />
          </div>

          <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end' }}>
            <button type="button" onClick={onClose}
              style={{ padding: '6px 12px', fontSize: '12px', fontWeight: '500', color: 'var(--text-muted)', backgroundColor: 'var(--card-bg)', border: '1px solid var(--text-muted)', cursor: 'pointer' }}>
              Anuluj
            </button>
            <button type="submit" disabled={loading}
              style={{ padding: '6px 12px', fontSize: '12px', fontWeight: '600', color: '#fff' , backgroundColor: 'var(--success)', border: '1px solid var(--success)', cursor: 'pointer' }}>
              {loading ? 'Przypisywanie...' : 'Przypisz pracownika'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmployeeModal;
